function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  d: "M21.25 22H2.75M18.63 20h-1.5"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeDasharray: "3.42 1.14",
  d: "M15.99 20H7.44"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  d: "M6.88 20h-1.5"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 7v12h-11V7z"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default SvgComponent;